var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("Calls in the last "+_vm._s(this.hours)+" hour(s) - "+_vm._s(this.total))]),_c('div',{staticClass:"chart",attrs:{"id":"LastHourOutcomePie"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }